import { Injectable, inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable({ providedIn: 'root' })
export class AuthorizationService {
  private oauthService = inject(OAuthService);

  static readonly RodixAdmin = 'RodixAdmin';
  private static readonly RodixEntwicklung = 'RodixEntwicklung';
  private static readonly SuperUserMandant = 'SuperUserMandant';
  private static readonly SuperUserKIS = 'SuperUserKIS';
  private static readonly SuperUserKomplett = 'SuperUserKomplett';
  private static readonly KISPartner = 'KIS-partner';
  private static readonly Softwarepartner = 'Softwarepartner';
  private static readonly User = 'User';

  isManager(): boolean {
    return this.hasOneOfTheRoles([
      AuthorizationService.RodixAdmin,
      AuthorizationService.SuperUserKomplett,
      AuthorizationService.SuperUserMandant,
    ]);
  }

  hasRole(role: string): boolean {
    return this.getRoles().includes(role);
  }

  isBetaTester(): boolean {
    const identityClaims = this.oauthService.getIdentityClaims();
    if (!identityClaims) {
      return false;
    }
    return !!identityClaims.betatester;
  }

  hasOnlyRole(role: string): boolean {
    const roles = this.getRoles();
    return roles.length === 1 && roles.includes(role);
  }

  hasOneOfTheRoles(roles: string[]): boolean {
    return roles.some((role) => this.hasRole(role));
  }

  isRodixAdmin(): boolean {
    return this.hasRole(AuthorizationService.RodixAdmin);
  }

  isRodixEntwicklung(): boolean {
    return this.hasRole(AuthorizationService.RodixEntwicklung);
  }

  isRodixAdminOrRodixEntwicklung(): boolean {
    return this.isRodixAdmin() || this.isRodixEntwicklung();
  }

  isSoftwarepartner(): boolean {
    return this.hasRole(AuthorizationService.Softwarepartner);
  }

  isKISPartner(): boolean {
    return this.hasRole(AuthorizationService.KISPartner);
  }

  isSuperUserKIS(): boolean {
    return this.hasRole(AuthorizationService.SuperUserKIS);
  }

  hasOnlyUserRole(): boolean {
    return this.hasOnlyRole(AuthorizationService.User);
  }

  getFullName(): string {
    const identityClaims = this.oauthService.getIdentityClaims();
    return (identityClaims?.name as string) ?? '';
  }

  getUserId(): string {
    const identityClaims = this.oauthService.getIdentityClaims();
    if (!identityClaims.sub) {
      throw new Error('No sub claim found in identity token, cannot determine user id');
    }
    return identityClaims.sub as string;
  }

  private getRoles(): string[] {
    const identityClaims = this.oauthService.getIdentityClaims();
    if (!identityClaims) {
      return [];
    }
    const roles = identityClaims['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'] as string[];
    if (!roles) {
      return [];
    }
    return roles;
  }
}
